import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from '../../auth/auth.guard';
import { MasterResolver } from '../master/master.resolver';
import { CommercialAgreementsComponent } from './commercial-agreements.component';
import { BusinessGuard } from 'src/app/auth/business.guard';

const routes: Routes = [
  {
    path: ':business',
    data: { breadcrumb: 'business' },

    children: [
      {
        path: 'commercial-agreements',
        component: CommercialAgreementsComponent,
        canActivate: [AuthGuard, BusinessGuard],
        resolve: [MasterResolver],
        data: { breadcrumb: 'Acuerdos Comerciales' },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CommercialAgreementsRoutingModule {}
